var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07352 3.49153V4.48369C10.188 4.83156 11 5.84044 11 7.04544V10.2399C11 11.7317 9.76324 12.9412 8.23849 12.9412H2.76216C1.23676 12.9412 0 11.7317 0 10.2399V7.04544C0 5.84044 0.812672 4.83156 1.92648 4.48369V3.49153C1.93305 1.56251 3.53078 0 5.49014 0C7.47579 0 9.07352 1.56251 9.07352 3.49153ZM5.5035 1.12526C6.83823 1.12526 7.92311 2.18623 7.92311 3.49153V4.34416H3.07732V3.47867C3.0839 2.1798 4.16877 1.12526 5.5035 1.12526ZM6.0756 9.35319C6.0756 9.66827 5.81918 9.91904 5.497 9.91904C5.1814 9.91904 4.92498 9.66827 4.92498 9.35319V7.92571C4.92498 7.61707 5.1814 7.3663 5.497 7.3663C5.81918 7.3663 6.0756 7.61707 6.0756 7.92571V9.35319Z",
    fill: "#FF5A62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockRed);
export default __webpack_public_path__ + "static/media/lock_red.421ac9ce.svg";
export { ForwardRef as ReactComponent };